require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-techhire-will-change-the-game.json") })
        }
      }, "path---blog-techhire-will-change-the-game");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-techhire-will-change-the-game!./.cache/json/blog-techhire-will-change-the-game.json
// module id = 1073
// module chunks = 231608221292675